import { createSelector } from 'reselect'

import { getIsAdmin, getSubCatalogs as getUserSubCatalogs } from 'models/user/selectors'
import sortByArray from 'utils/sortByArray'

const getById = (state) => state.furniture.byId
const getSelectedId = (state) => state.furniture.selectedId
const getSwapAnchorId = (state) => state.furniture.swapAnchorId
export const getSelectedSwapDetailsId = (state) => state.furniture.selectedSwapDetailsId
export const getStackEnabled = (state) => state.furniture.stackEnabled
export const getFilterResult = (state) => state.furniture.filterResult
export const getFurnitureIsLoading = (state) => state.furniture.isLoading
export const getFurnitureIsLoadingByIds = (state) => state.furniture.isLoadingByIds
export const getIsSwappablesLoading = (state) => state.furniture.isSwappablesLoading
export const getIsCategoriesLoading = (state) => state.furniture.isCategoriesLoading
export const getFilter = (state) => state.furniture.filter
export const getCategories = (state) => state.furniture.categories

export const getFurnitureById = createSelector([getById], (itemsById) => itemsById)

export const getSubCatalogs = createSelector(
    [getById, getUserSubCatalogs, getIsAdmin],
    (itemsById, userSubCatalogs, isAdmin) => {
        if (isAdmin) {
            const result = new Set()
            Object.values(itemsById).forEach((item) => {
                if (item.subCatalogs) {
                    item.subCatalogs.forEach((subCat) => {
                        result.add(subCat)
                    })
                }
            })
            return sortByArray(Array.from(result), [(a) => a, userSubCatalogs], (a) => a)
        }
        return userSubCatalogs
    },
)

export const getFurnitureByFilter = createSelector([getFurnitureById, getFilterResult], (itemsById, filterResult) =>
    filterResult.ids.map((fId) => itemsById[fId]).filter((i) => !!i && !i.hidden),
)

export const getCanLoadMore = createSelector([getFilterResult], (filterResult) => filterResult.hasNext)

export const getNumberFurnitureItems = createSelector([getFilterResult], (filterResult) => filterResult.count)

export const getIsFilterActive = createSelector(
    getFilter,
    (filter) => filter.category !== '*' || filter.subCategory !== '*' || filter.subCatalog !== '*',
)

export const getSelectedFurnitureData = createSelector([getFurnitureById, getSelectedId], (furniture, selectedId) => {
    if (!furniture || !furniture[selectedId]) {
        return null
    }
    return {
        ...furniture[selectedId],
    }
})

export const getSelectedSwapFurnitureData = createSelector(
    [getFurnitureById, getSwapAnchorId],
    (furniture, selectedId) => furniture[selectedId] || null,
)

export const getSelectedSwapDetailsFurnitureData = createSelector(
    [getFurnitureById, getSelectedSwapDetailsId],
    (furniture, selectedId) => furniture[selectedId] || null,
)

export const getSelectedFurnitureRecommendedListData = createSelector(
    [getSelectedFurnitureData, getFurnitureById],
    (selectedFurnitureData, itemsById) => {
        if (!selectedFurnitureData || !selectedFurnitureData.recommended) {
            return null
        }
        const { recommended } = selectedFurnitureData
        return Object.values(itemsById).filter(({ id: itemId }) => recommended.includes(itemId))
    },
)

export const getSelectedFurnitureSwappableItemsData = createSelector(
    [getSelectedSwapFurnitureData, getFurnitureById],
    (selectedFurnitureData, itemsById) => {
        if (!selectedFurnitureData || !selectedFurnitureData.swappableItems) {
            return null
        }

        const { swappableItems: swappableItemIds } = selectedFurnitureData

        const swappableItemsData = swappableItemIds.map((swapId) => itemsById[swapId]).filter((item) => !!item)

        return swappableItemsData
    },
)
